module.exports = __webpack_public_path__ + "/login_ui/img/kg-d056ead3dce05959bcf37cd95af3c9a2.svg";